import { render, staticRenderFns } from "./HomeWidgetFinance.vue?vue&type=template&id=54fef85c&scoped=true&"
import script from "./HomeWidgetFinance.vue?vue&type=script&lang=js&"
export * from "./HomeWidgetFinance.vue?vue&type=script&lang=js&"
import style0 from "./HomeWidgetFinance.vue?vue&type=style&index=0&id=54fef85c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54fef85c",
  null
  
)

export default component.exports